import React, { useState } from 'react';
import './Projects.css';
import dialAidImage from './dialaid.png';
import doctorDoctorImage from './doctor-doctor.png';
import gitReadyImage from './git-ready.png';
import raiinetImage from './raiinet.png';
import studypayImage from './studypay.png';
import adaptiveWorkflowImage from './federato.png';
import networkVisualizerImage from './network-visualizer.png';
import abaBudImage from './aba-bud.png';
import dopplerResearchImage from './doppler.png';
import portfolioImage from './portfolio.png';
import runeImage from './rune.png';

const Projects = () => {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      title: 'Rune',
      subtitle: 'Programming Language & Compiler',
      description: 'Statically-typed programming language and compiler built with Rust, supporting union types, ad-hoc polymorphism, and compile-time type checking. Features recursive-descent and Pratt parsing, and lowers to optimized LLVM IR. Includes an NLP-style video editor for translating code into animations.',
      imageUrl: runeImage,
      link: 'https://github.com/Blank9999/rune',
      category: 'systems',
      featured: true,
      tags: ['Rust', 'LLVM IR', 'C', 'Type Systems', 'Pratt Parsing', 'Compilers'],
    },
    {
      title: 'DIAL-AID',
      subtitle: 'Real-time Fall Detection iOS App',
      description: 'iOS app preventing fall-related injuries in the elderly using an ensemble ML model (95% accuracy) on accelerometer & gyroscope telemetry. Built in Swift & CoreMotion with <50ms real-time analysis, CoreML inference, and Firebase backend.',
      imageUrl: dialAidImage,
      link: 'https://github.com/Ayu190505/DIALAID',
      category: 'ml',
      featured: true,
      tags: ['Swift', 'CoreML', 'CoreMotion', 'Firebase', 'Scikit-Learn', 'NumPy'],
    },
    {
      title: 'Adaptive Workflow Engine',
      subtitle: 'CxC 2025 Winner · Federato RiskOps',
      description: 'Visualizes 100k+ enterprise sessions using Three.js and D3.js, integrating XGBoost & Markov Chain models (83% accuracy) to predict user conversion bottlenecks with causal inference recommendation pipelines.',
      imageUrl: adaptiveWorkflowImage,
      link: 'https://devpost.com/software/adaptive-workflow-engine-for-user-engagement-optimization',
      category: 'ml',
      featured: true,
      tags: ['Three.js', 'Flask', 'D3.js', 'XGBoost', 'Markov Chains', 'Plotly'],
    },
    {
      title: 'Doctor Doctor',
      subtitle: 'AI-Driven Multimodal Clinical Diagnostics',
      description: 'Fullstack AI diagnostic platform featuring ResNet-50 CNN wound classification (93% accuracy), Librosa acoustic cough analysis, OpenAI medical summary generation, and automated PDF report synthesis.',
      imageUrl: doctorDoctorImage,
      link: 'https://youtu.be/yQF0N9OLpvM?si=zTtj3lA4gGTCftKg',
      category: 'ml',
      tags: ['React', 'Flask', 'PyTorch', 'TensorFlow', 'Librosa', 'OpenAI API'],
    },
    {
      title: 'Git Ready',
      subtitle: 'LLM-Powered Git CLI Tool',
      description: 'Developer CLI tool enhancing code documentation and git workflows with custom git extensions, automated AST-aware diff parsing, and Gemini-prompted intelligent inline code comments.',
      imageUrl: gitReadyImage,
      link: 'https://github.com/Ayu190505/git-formatting-documentation-command',
      category: 'systems',
      tags: ['Python', 'Bash', 'Gemini API', 'CLI', 'Git Internals'],
    },
    {
      title: 'RAIInet',
      subtitle: 'Modular X11 Multiplayer Strategy Game',
      description: 'Interactive 2-4 player Linux game with X11 graphics built in modern C++. Clean object-oriented architecture (3,000+ lines, 15 modules) implementing MVC and Single Responsibility design patterns.',
      imageUrl: raiinetImage,
      link: 'https://github.com/Ayu190505/RAIInet/',
      category: 'systems',
      tags: ['C++', 'OOP', 'X11', 'Linux', 'Design Patterns'],
    },
    {
      title: 'Network Protocol Visualizer',
      subtitle: '3D Interactive Packet Simulator',
      description: 'Interactive 3D WebGL application developed in Unity & C# simulating real-time network protocol mechanics (TCP handshake, UDP packet streaming, NAT routing) for educational network analysis.',
      imageUrl: networkVisualizerImage,
      link: 'https://github.com/Ayu190505/network-protocol-visualizer',
      category: 'systems',
      tags: ['Unity', 'C#', 'WebGL', 'Computer Networks', 'Blender'],
    },
    {
      title: 'StudyPay',
      subtitle: 'Campus E-Payment & Transaction App',
      description: 'Android e-payment app serving 2,000+ users with secure Firebase auth, real-time database syncing with 99.9% uptime, 30% lower latency, and Material Design UI.',
      imageUrl: studypayImage,
      link: 'https://www.youtube.com/watch?v=Dh08bmTgFUc',
      category: 'apps',
      tags: ['Java', 'Android SDK', 'Firebase', 'Material Design'],
    },
    {
      title: "Ayaan's Portfolio & Space Realm",
      subtitle: 'Interactive React & 3D Web Experience',
      description: 'Modern developer portfolio built with React, Three.js 3D space navigation game, glassmorphic terminal aesthetics, custom animations, and responsive architecture.',
      imageUrl: portfolioImage,
      link: 'https://www.ayaan-nadamal.com',
      category: 'apps',
      tags: ['React', 'Three.js', 'WebGL', 'Tailwind', 'CSS3'],
    },
    {
      title: 'ABA BUD',
      subtitle: 'Campus Navigation & Onboarding Platform',
      description: 'Android newcomer onboarding prototype integrating map geolocation APIs and automated student buddy matchmaking with a 6-layer UX architecture designed in Adobe XD.',
      imageUrl: abaBudImage,
      link: 'https://github.com/Ayu190505/aba-bud',
      category: 'apps',
      tags: ['Java', 'Android Studio', 'Geolocation', 'Adobe XD'],
    },
    {
      title: 'Rotational Doppler Research',
      subtitle: 'Acoustic Physics & Celestial Harmonics',
      description: 'Experimental investigation analyzing rotational Doppler frequency shifts via piezoelectric sensor telemetry, FFT spectral diagnostics, and harmonic regressions with orbital redshift correlations.',
      imageUrl: dopplerResearchImage,
      link: '#',
      category: 'research',
      tags: ['Signal Processing', 'Phyphox', 'FFT', 'Audacity', 'Physics'],
    },
  ];

  const filteredProjects = filter === 'all'
    ? projects
    : projects.filter(p => p.category === filter);

  return (
    <div className="projects-page">
      <div className="projects-content-wrapper">
        <div className="projects-header-section">
          <h2 className="projects-main-heading">Featured Engineering Projects</h2>
          <p className="projects-sub-heading">
            A showcase of compilers, machine learning systems, low-level tooling, and creative software.
          </p>

          {/* Filter Bar */}
          <div className="projects-filter-bar">
            <button
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All Projects ({projects.length})
            </button>
            <button
              className={`filter-btn ${filter === 'systems' ? 'active' : ''}`}
              onClick={() => setFilter('systems')}
            >
              Compilers & Systems
            </button>
            <button
              className={`filter-btn ${filter === 'ml' ? 'active' : ''}`}
              onClick={() => setFilter('ml')}
            >
              AI & Machine Learning
            </button>
            <button
              className={`filter-btn ${filter === 'apps' ? 'active' : ''}`}
              onClick={() => setFilter('apps')}
            >
              Applications & 3D
            </button>
          </div>
        </div>

        <div className="projects-grid">
          {filteredProjects.map((project, index) => (
            <div className={`project-card ${project.featured ? 'is-featured' : ''}`} key={index}>
              <div className="project-image-container">
                <img src={project.imageUrl} alt={project.title} className="project-thumbnail" />
                {project.featured && <span className="project-feature-badge">Featured</span>}
              </div>

              <div className="project-card-content">
                <div className="project-card-header">
                  <h3 className="project-title">{project.title}</h3>
                  {project.subtitle && <span className="project-subtitle">{project.subtitle}</span>}
                </div>

                <p className="project-description">{project.description}</p>

                <div className="project-card-footer">
                  <div className="project-tags">
                    {project.tags.map((tag, tagIndex) => (
                      <span className="project-tag" key={tagIndex}>
                        {tag}
                      </span>
                    ))}
                  </div>

                  {project.link && project.link !== '#' && (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link-btn"
                    >
                      <span>Explore Project</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="7" y1="17" x2="17" y2="7"></line>
                        <polyline points="7 7 17 7 17 17"></polyline>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
